import React from 'react';
import { InfographicPost } from './components/InfographicPost';
export function App() {
  return <div className="min-h-screen w-full bg-[#0B0E1A] flex items-center justify-center p-4 sm:p-8 relative overflow-hidden" data-id="element-0">
      {/* Subtle background glow behind the post */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-wp-teal/5 rounded-full blur-3xl pointer-events-none" data-id="element-1" />

      <InfographicPost data-id="element-2" />
    </div>;
}